import { bl_cpcommerce_form_answer_attachment_RowClass } from '../../dbschema/bl_cpcommerce_form_answer_attachment.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceFormAnswerAttachmentContainerModel extends BaseContainerModel {
  bl_cpcommerce_form_answer_attachment: bl_cpcommerce_form_answer_attachment_RowClass = new bl_cpcommerce_form_answer_attachment_RowClass();
}
